import { ValidatorService } from '../tools/validator.service';
import { AutenticacionService } from '../autenticacion.service';
import { Http, URLSearchParams } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from '../tools/errors.service';

@Injectable()
export class NominasService {

  private service_url : string = '';
  private service_insoluto_url : string = '';
  private service_soluto_url : string = '';

  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/creditosNominas';
    this.service_insoluto_url = this.constantsService.apiURL + '/calculo/insoluto/creditoMaximo';
    this.service_soluto_url = this.constantsService.apiURL + '/calculo/soluto/creditoMaximo';
  }

  public save( credito : object) {
    return this.http.post(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public update( credito : object) {
    return this.http.put(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public get(idCreditos : number){
    const service = this.service_url + '/' + idCreditos;
    return this.http.get(service  , this.authService.getAuthHeaders());
  }

  public getCreditoMaximoInsoluto(tasa : number, capacidad_pago : number, 
    plazo_periodo : number, plazo_medida : string, periodicidad: number) {
    let myParams = new URLSearchParams();
    
    myParams.append('tasa', tasa.toString());
    myParams.append('capacidad_pago', capacidad_pago.toString());
    myParams.append('plazo_periodo', plazo_periodo.toString());
    myParams.append('plazo_medida', plazo_medida.toString());
    myParams.append('periodicidad', periodicidad.toString());

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return this.http.get(this.service_insoluto_url , myoptions);
  }

  public getCreditoMaximoSoluto(tasa : number, capacidad_pago : number, 
    plazo_periodo : number, plazo_medida : string, periodicidad: number) {
    let myParams = new URLSearchParams();
    
    myParams.append('tasa', tasa.toString());
    myParams.append('capacidad_pago', capacidad_pago.toString());
    myParams.append('plazo_periodo', plazo_periodo.toString());
    myParams.append('plazo_medida', plazo_medida.toString());
    myParams.append('periodicidad', periodicidad.toString());

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return this.http.get(this.service_soluto_url , myoptions);
  }

  public validateCapacidadPago(nomina : any){
    let error = {};

    if(!this.validatorService.required(nomina.idConvenios)){
        error["idConvenios"] = this.errorService.required;
    }

    if(!this.validatorService.required(nomina.sueldo_bruto)){
        error["sueldo_bruto"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(nomina.pension)){
        error["pension"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(nomina.infonavit)){
        error["infonavit"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(nomina.imss)){
        error["imss"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(nomina.fonacot)){
        error["fonacot"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(nomina.profimex)){
        error["profimex"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(nomina.otros)){
        error["otros"] = this.errorService.required;
    }

    return error;
  }

  public validate(credito : any){
    let error = {};
    let prestamo = credito.prestamo;
    let cliente = credito.cliente;
    let nomina = credito.nomina;

    
    if(!this.validatorService.required(prestamo.plazo_periodo)){
        error["plazo_periodo"] = this.errorService.required;
    }else if(!this.validatorService.numeric(prestamo.monto_prestamo)){
      //Se debe ingresar el crédito y este debe ser superior a 0
      error["monto_maximo_prestamo"] = this.errorService.required;
    }else if(Number(prestamo.monto_prestamo) > Number(prestamo.monto_maximo)){
      //El crédito seleccionado debe ser menor al máximo
      error["monto_maximo_prestamo"] = 'El crédito debe ser menor al monto máximo ' + prestamo.monto_maximo;
    }

    if(!this.validatorService.required(cliente.nombre)){
        error["nombre"] = this.errorService.required;
    }

    if(!this.validatorService.required(cliente.email)){
        error["email"] = this.errorService.required;
    }else if (!this.validatorService.email(cliente.email)) {
        error['email'] = this.errorService.email;
    }

    let nominaErrors = this.validateCapacidadPago(nomina);
    
    //Pasar los errores de nomina al objeto de errores generales (error)
    Object.assign(error, nominaErrors);

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/creditos/nominas.service.ts